import { Box, IconButton, Typography } from '@mui/material'
import Link from 'next/link'
import React from 'react'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import CopyButton from './CopyButton'
import { shortenAddress } from '@/utils/address'
import { CHAIN_INFO } from '@/constants'

const ContractAddress = ({ title, address, chainId }: { title: string; address: string; chainId: number }) => {
  return (
    <Box
      sx={{
        mt: 20,
        display: 'flex',
        alignItems: { xs: 'unset', md: 'center' },
        flexDirection: { xs: 'column', md: 'row' },
      }}
    >
      <Typography
        sx={{
          color: 'rgba(255, 255, 255, 0.90)',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: 'normal',
        }}
      >
        {title}
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', ml: { xs: 'unset', md: 'auto' } }}>
        <Typography
          sx={{
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: 'normal',
            textDecorationLine: 'underline',
          }}
        >
          {shortenAddress(address)}
        </Typography>

        <CopyButton
          text={address}
          buttonProps={{ size: 'small', color: 'primary', sx: { ml: 4 } }}
          iconProps={{ sx: { width: 16, height: 16 } }}
        />

        <Link href={`${CHAIN_INFO?.[chainId].blockExplorers.default.url}/token/${address}`} target="_blank">
          <IconButton size="small">
            <OpenInNewIcon sx={{ width: 16, height: 16 }} />
          </IconButton>
        </Link>
      </Box>
    </Box>
  )
}

export default ContractAddress
